import { TargetAnnotationProperties } from './graphAnnotationProperties';

export interface ProgramTargetProperties {
	consecutiveDays: number | null;
	errorCorrection: string;
	goalName: string;
	name: string;
	reinforcement: string;
	responsePercentage: number | null;
	sd: string;
	targetInstructions: string;
}

export interface GetTargetProperties {
	id: string;
	programId: string;
}

export interface GetTargetsProperties {
	includeMastered?: boolean;
	programId: string;
}

export interface CreateProgramTargetProperties extends ProgramTargetProperties {
	masteryCriteria: number;
	steps?: Array<{ name: string }>;
	typeId: TargetTypes;
}

export interface MoveTargetProperties extends GetTargetProperties {
	toProgramId: string;
}

export interface UpdateTargetProperties extends GetTargetProperties {
	data: ProgramTargetProperties;
}

export interface AddTargetSteps {
	data: Array<TargetStepsDataProperties | UpdateTargetStepsProperties>;
	id: string;
	programId: string;
}

export enum TargetTypes {
	'DTT' = 0,
	'TA' = 4,
}

export enum MasteryTypes {
	'AUTOMATIC' = 1,
	'MANUAL' = 2,
}

export interface TargetStepsDataProperties {
	controlId: string;
	enabled: boolean;
	name: string;
	note: string;
	orderNumber: number;
	useForMastery: boolean;
}

export interface UpdateTargetStepsProperties extends TargetStepsDataProperties {
	id: string;
}

export interface StepProperties {
	promptCodeId: string;
	stepId: string;
}

export interface TargetTypeProperties {
	id: number;
	name: string;
}

export interface TargetProperties extends ProgramTargetProperties {
	clientId: string;
	dateMastered: string;
	dateOpened: string;
	id: string;
	isReopened: boolean;
	masteryCriteria: TargetTypeProperties;
	programId: string;
	status: TargetTypeProperties;
	type: TargetTypeProperties;
}

export interface ClientTargetProperties extends TargetProperties {
	program: {
		id: string;
		name: string;
	};
}

export interface TargetHistoryProperties {
	id: string;
	madeAt: string;
	message: string;
	targetId: string;
}

export interface MoveOptionProperties {
	program: { id: string; name: string };
	skillArea: { id: string; name: string };
}

export interface ActiveTargetProperties {
	id: string;
	name: string;
	status: number;
	steps: UpdateTargetStepsProperties[] | null;
	targetInstructions: string;
	type: number;
}

export interface TargetAnnotationsAllProperties extends TargetAnnotationProperties {
	id: string;
}

export interface GetClientTargetsProperties {
	clientId: string;
	// Funding stream to scope targets to. Omit/null = insurance/DOE (shared tree); set = funder-specific (e.g. ELC).
	funderId?: string | null;
	page?: string;
	pageSize?: string;
	searchString?: string;
}
